module.exports = {
	manageSettings: '/manage/settings',
	signedIn: '/goV2IntroWizard/signed-in',
	sso: '/auth/accounts',
};
